import type { NextPage } from 'next'

import LayoutWithNavigation from '@/components/layoutWithNavigation'
import MicroEntrepreneur from '@/components/microEntrepreneur'

export async function getStaticProps() {
  return {
    props: {
      title: 'Agricultural Application for Micro-Entrepreneur Solutions',
      description:
        'App for micro-entrepreneurs leads to making farming more socially, economically and environmentally sustainable is the key to serve more and more farmers.',
    },
  }
}

const SolutionForMicroEntrepreneur: NextPage = () => (
  <LayoutWithNavigation>
    <MicroEntrepreneur />
  </LayoutWithNavigation>
)

export default SolutionForMicroEntrepreneur
